export type JurisdictionId =
  | 'global-brain'
  | 'united-states'
  | 'canada'
  | 'european-union'
  | 'united-kingdom'
  | 'australia'
  | 'mexico'
  | 'brazil'
  | 'japan'
  | 'germany';

export type JurisdictionGroupId = 'ALL_NATIONS' | 'ACTIVE_BRAINS' | 'FOUNDATIONAL' | 'COMING_SOON';

export type JurisdictionTag = 'Full' | 'Growing' | 'Foundational' | 'Soon';

export interface IJurisdiction {
  id: JurisdictionId;
  name: string;
  flag: string;
  group: JurisdictionGroupId;
  tag?: JurisdictionTag;
  disabled?: boolean;
}

export interface IJurisdictionGroup {
  id: JurisdictionGroupId;
  label: string;
  items: IJurisdiction[];
}

export const JURISDICTION_GROUPS: IJurisdictionGroup[] = [
  {
    id: 'ALL_NATIONS',
    label: 'All Nations',
    items: [{ id: 'global-brain', name: 'Global Brain', flag: '🌐', group: 'ALL_NATIONS' }],
  },
  {
    id: 'ACTIVE_BRAINS',
    label: 'Active Brains',
    items: [
      {
        id: 'united-states',
        name: 'United States',
        flag: '🇺🇸',
        group: 'ACTIVE_BRAINS',
        tag: 'Full',
      },
      { id: 'canada', name: 'Canada', flag: '🇨🇦', group: 'ACTIVE_BRAINS', tag: 'Growing' },
    ],
  },
  {
    id: 'FOUNDATIONAL',
    label: 'Foundational',
    items: [
      {
        id: 'european-union',
        name: 'European Union',
        flag: '🇪🇺',
        group: 'FOUNDATIONAL',
        tag: 'Foundational',
        disabled: true,
      },
      {
        id: 'united-kingdom',
        name: 'United Kingdom',
        flag: '🇬🇧',
        group: 'FOUNDATIONAL',
        tag: 'Foundational',
        disabled: true,
      },
      {
        id: 'australia',
        name: 'Australia',
        flag: '🇦🇺',
        group: 'FOUNDATIONAL',
        tag: 'Foundational',
        disabled: true,
      },
      {
        id: 'mexico',
        name: 'Mexico',
        flag: '🇲🇽',
        group: 'FOUNDATIONAL',
        tag: 'Foundational',
        disabled: true,
      },
    ],
  },
  {
    id: 'COMING_SOON',
    label: 'Coming Soon',
    items: [
      {
        id: 'brazil',
        name: 'Brazil',
        flag: '🇧🇷',
        group: 'COMING_SOON',
        tag: 'Soon',
        disabled: true,
      },
      { id: 'japan', name: 'Japan', flag: '🇯🇵', group: 'COMING_SOON', tag: 'Soon', disabled: true },
      {
        id: 'germany',
        name: 'Germany',
        flag: '🇩🇪',
        group: 'COMING_SOON',
        tag: 'Soon',
        disabled: true,
      },
    ],
  },
];

export const JURISDICTIONS: IJurisdiction[] = JURISDICTION_GROUPS.flatMap((g) => g.items);

export const DEFAULT_JURISDICTION_ID: JurisdictionId = 'united-states';

export function findJurisdiction(id: JurisdictionId): IJurisdiction {
  return JURISDICTIONS.find((j) => j.id === id) || JURISDICTIONS[0];
}
